module.exports = __webpack_public_path__ + "img/placeholder.417ec24a.svg";